export default function SectionLabel({ number, label, children }) {
  return (
    <div className="flex items-center gap-3 mb-4">
      {number && (
        <span className="font-serif italic text-sm text-white/40">{number}</span>
      )}
      <span
        className="h-px w-8"
        style={{ background: "rgba(212,175,55,0.6)" }}
      />
      <p className="eyebrow">{label || children}</p>
    </div>
  );
}
